import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { customersApi } from './api/customersApi';
import { CustomerPicker } from './components/CustomerPicker';

const customerPickerFormField = FormFieldBlueprint.make({
  name: 'customer-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'CustomerPicker',
        component: CustomerPicker,
      }),
  },
});

export const customerRegistryScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [customersApi, customerPickerFormField],
});
